/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useRef, useEffect, React } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import SimplifiedHeader from '../components/SimplifiedHeader'
import Cta from '../components/Cta'
import RegistrationForm from './RegistrationForm'
import NotificationBar from '../components/NotificationBar'
import LoadingBar from 'react-top-loading-bar';
import useTitle from '../hooks/useTitle'
import { useUser } from '../providers/UserProvider'
import { useTheme } from '../providers/ThemeProvider'
import {
  useHistory,
  useLocation,
  useParams
} from "react-router-dom";
import { useCookies } from 'react-cookie';

import AuthService from '../services/AuthService'
import AffiliateService from '../services/AffiliateService'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const queryString = require('query-string');

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ConfirmationView = () => {
  return (
    <>
      <SimplifiedHeader showLogin="true" />
      <div className="container mx-auto bg-white">
        <div className="bg-white">
          <div className="md:max-w-login-container mx-auto text-center py-12">
            <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">One last thing…</span>
                </h2>
            </div>
  
            <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
              <span className="text-grey-dark text-subtitle-mobile md:text-subtitle">Check your email for the link to verify your account. </span>
            </div>
          </div>
      </div>
    </div>
    </>
  )
}

function RegistrationView(props) {
  const AUTH_URL = AuthService.AUTH_URL;
  const REDIRECT_URL = AuthService.REDIRECT_URL;
  const COGNITO_CLIENT_ID = AuthService.COGNITO_CLIENT_ID;
  const token = props.token;

  const loadingBarRef = useRef(null);

  const [openForm, setOpenForm] = useState(true);

  return (
    <>
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
      <div className="container">
        <SimplifiedHeader showLogin="true" />
      </div>
      <NotificationBar />
      <div className="container mx-auto bg-white">
        <div className="bg-white">
          <div className="md:max-w-login-container mx-auto text-center py-12">
            <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">Create an account to start saving.</span>
                </h2>
            </div>
  
            <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
              <span className="text-grey-dark text-subtitle-mobile md:text-subtitle">By becoming a Member of The Convoy, you join thousands of small businesses in getting the savings you deserve!</span>
            </div>
    
            <div className="mt-5 md:mt-10">
              <small className="font-subtitle text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">By signing up, I agree to the <a className="border-b-2" href="/terms-of-service">Terms of Use</a> and <a className="border-b-2" href="/privacy-policy">Privacy Policy</a></small>
            </div>
  
            <div className="mt-5 md:mt-10 flex justify-center">
              <a 
                className="inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-subtitle-mobile md:text-subtitle rounded-full text-black bg-white hover:text-white hover:bg-blue-700"
                href={`${AUTH_URL}/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URL}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=aws.cognito.signin.user.admin+email+openid+profile`}
              ><FontAwesomeIcon icon={['fab', 'google']} /><span className="ml-4">Continue with Google</span></a>
            </div>
  
            <div className="mt-5 md:mt-10 md:w-120 font-content relative mx-auto">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">Or sign up with email</span>
              </div>
            </div>
  
            <RegistrationForm token={token} setConfirmed={props.setConfirmed} loadingBarRef={loadingBarRef} />
  
          </div>
      </div>
    </div>
    </>
  )
}

function AffiliateRegistrationView(props) {
  const AUTH_URL = AuthService.AUTH_URL;
  const REDIRECT_URL = AuthService.REDIRECT_URL;
  const COGNITO_CLIENT_ID = AuthService.COGNITO_CLIENT_ID;

  const loadingBarRef = useRef(null);

  const [openForm, setOpenForm] = useState(true);
  const [ theme, themeDispatch ] = useTheme();

  return (
    <>
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
      <div className={classNames((theme.headerDark?'bg-convoy-blue':"bg-white"))}>
        <div className="container">
          <SimplifiedHeader showLogin="true" />
        </div>
      </div>
      <NotificationBar />
      <div className="mx-auto bg-white" style={{height:"88vh"}}>
        <div className="bg-white h-full">
          <div className="max-w-[1440px] h-full xl:grid xl:grid-cols-2 mx-auto ">

            <div 
              className="hidden xl:block bg-cover bg-center"
              style={{ backgroundImage: "url('" + theme.heroImage + "')" }}
            >
              <div className="w-full h-full bg-blue-500/50 flex">
                <div className="mt-auto px-12 pb-12">
                  <h2 className="font-secondary text-white text-headline-1-lg">
                    {theme.overlayHeader}
                  </h2>
                  <p className="font-primary text-white text-body-1 mt-5 ">
                    {theme.overlaySubheader}
                  </p>
                </div>
              </div>
            </div>

            <div className="form py-12 px-8 text-center">
              <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">
                    {theme.regFormHeader}
                  </span>
                </h2>
              </div>
  
              <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
                <span className="text-grey-dark text-subtitle-mobile md:text-subtitle">
                  {theme.regFormSubheader}
                </span>
              </div>
      
              <div className="mt-5 md:mt-10">
                <small className="font-subtitle text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">By signing up, I agree to the <a className="border-b-2" href="/terms-of-service">Terms of Use</a> and <a className="border-b-2" href="/privacy-policy">Privacy Policy</a></small>
              </div>
    
              <div className="mt-5 md:mt-10 flex justify-center">
                <a 
                  className="inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-subtitle-mobile md:text-subtitle rounded-full text-black bg-white hover:text-white hover:bg-blue-700"
                  href={`${AUTH_URL}/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URL}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=aws.cognito.signin.user.admin+email+openid+profile`}
                ><FontAwesomeIcon icon={['fab', 'google']} /><span className="ml-4">Continue with Google</span></a>
              </div>
    
              <div className="mt-5 md:mt-10 md:w-120 font-content relative mx-auto">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">Or sign up with email</span>
                </div>
              </div>
    
              <RegistrationForm token={props.token} setConfirmed={props.setConfirmed} loadingBarRef={loadingBarRef} />
    
            </div>
            </div>

      </div>
    </div>
    </>
  )
}

const RegistrationApp = (props) => {
  let token = null;
  let branding = null;
  let params = queryString.parse(useLocation().search);
  let { affiliateId } = useParams();

  const [ confirmed, setConfirmed ] = useState(false);
  const [user, userDispatch] = useUser();
  const [ theme, themeDispatch ] = useTheme();
  const [ cookies, setCookies ] = useCookies([]);

  if (params._ref) {
    token = params._ref;
  }


  console.log(affiliateId);

  useEffect(() => {
    if (params._a) {
      branding = AffiliateService.getBrandingByRefId(params._a);
      themeDispatch({ type: 'theme/set', payload: {...branding, "affiliateId": branding.affiliateId }});

      setCookies("affiliate-link", branding.affiliateId);
    } else if(affiliateId) {
      branding = AffiliateService.getAffiliateBranding(affiliateId);
      themeDispatch({ type: 'theme/set', payload: {...branding, "affiliateId": branding.affiliateId }});

      setCookies("affiliate-link", branding.affiliateId);
    }
  }, []);


  useTitle("Welcome | The Convoy | Save on everyday business expenses.");

  return (
    <div>
      {theme.affiliateId &&
        ((!confirmed)? <AffiliateRegistrationView token={token} setConfirmed={setConfirmed} /> : <ConfirmationView /> )
      }

      {!theme.affiliateId &&
        ((!confirmed)? <RegistrationView token={token} setConfirmed={setConfirmed} /> : <ConfirmationView /> )
      }
    </div>
  )
}


export default RegistrationApp;
